var map = {
	"./bank-transfer.svg": 827,
	"./betnearn-ico.svg": 828,
	"./birthday-bonus-ico.svg": 829,
	"./birthday.svg": 830,
	"./bonus-code-ico.svg": 831,
	"./bonus-ico.svg": 832,
	"./bonus-received-ico.svg": 833,
	"./bonus.svg": 834,
	"./business-account-upgrade-ico.svg": 835,
	"./check-in-daily-ico.svg": 836,
	"./checked.svg": 837,
	"./cloud-pointer.svg": 838,
	"./coin.svg": 839,
	"./crypto.svg": 840,
	"./daily-bonus-ico.svg": 841,
	"./daily-limit.svg": 842,
	"./deposit-delay-bonus-ico.svg": 843,
	"./e-wallet.svg": 844,
	"./earn-x33-coin-ico.svg": 845,
	"./email.svg": 846,
	"./facebook.svg": 847,
	"./feedback.svg": 848,
	"./first-bet-ico.svg": 849,
	"./games-rebate-ico.svg": 850,
	"./info.svg": 851,
	"./instagram.svg": 852,
	"./instant-rebate.svg": 853,
	"./live-casino-rebate-ico.svg": 854,
	"./lucky-spin-ico.svg": 855,
	"./messenger.svg": 856,
	"./mobile-app-deposit-ico.svg": 857,
	"./monthly-cash.svg": 858,
	"./msg-activity.svg": 859,
	"./msg-ann.svg": 860,
	"./msg-notice.svg": 861,
	"./new-icon.svg": 862,
	"./people-ico.svg": 863,
	"./quick-pay.svg": 864,
	"./rescue-bonus-ico.svg": 865,
	"./rescue-lc-ico.svg": 866,
	"./rescue-slots-ico.svg": 867,
	"./return.svg": 868,
	"./sc-bc-active-ico.svg": 869,
	"./sc-bc-ico.svg": 870,
	"./sc-bi-active-ico.svg": 871,
	"./sc-bi-ico.svg": 872,
	"./sc-mail-active-ico.svg": 873,
	"./sc-mail-ico.svg": 874,
	"./sc-mp-active-ico.svg": 875,
	"./sc-mp-ico.svg": 876,
	"./sc-pin-active-ico.svg": 877,
	"./sc-pin-ico.svg": 878,
	"./slots-rebate-ico.svg": 879,
	"./sms.svg": 880,
	"./sports-rebate-ico.svg": 881,
	"./telegram.svg": 882,
	"./twitter.svg": 883,
	"./vip-up-level-ico.svg": 884,
	"./vip-weekly-bonus.svg": 885,
	"./wallet-balance-interest-ico.svg": 886,
	"./wallet-ico.svg": 887,
	"./weekly-tournament-ico.svg": 888,
	"./welcome-bonus-188-ico.svg": 889,
	"./welcome-bonus-ico.svg": 890,
	"./whatsapp-original.svg": 891,
	"./whatsapp.svg": 892,
	"./withdrawal-delay-bonus-ico.svg": 893,
	"./withdrawal.svg": 894,
	"./x33-coin.svg": 895
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63;